import { render } from "./VaccineSales.vue?vue&type=template&id=f0682956"
import script from "./VaccineSales.vue?vue&type=script&lang=js"
export * from "./VaccineSales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pharmarcy/VaccineSales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f0682956"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0682956', __exports__)) {
    api.reload('f0682956', __exports__)
  }
  
  module.hot.accept("./VaccineSales.vue?vue&type=template&id=f0682956", () => {
    api.rerender('f0682956', render)
  })

}


export default __exports__